/*global google*/

import React, { Component } from 'react';

import TimeoutSignsParkinglocationsSelect from './TimeoutSignsParkinglocationsSelect';
import ParkinglocationModel from './ParkinglocationModel';

import { Form, Input, InputNumber, Button, Modal, Select, Divider, Switch, Icon, TimePicker, Col } from 'antd';
import { withState } from 'recompose';
import { compose, withProps } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";
import moment from 'moment';
import { values } from 'lodash';
const FormItem = Form.Item;

const SelectableMap = compose(
  withProps({
    loadingElement: <div style={{ height: `300px` }} />,
    containerElement: <div style={{ height: `300px` }} />,
    mapElement: <div style={{ height: `100%` }} />
  }),
  withGoogleMap
)(props => (
  <GoogleMap
    zoom={props.zoom}
    center={{
      lat: props.centerLat || props.lat || 50.0008306,
      lng: props.centerLng || props.lng || 14.6637575
    }}
    options={{
      streetViewControl: false,
      mapTypeControl: true,
      fullscreenControl: true,
      draggableCursor: 'crosshair',
      tilt: 0,
      styles: [
        {
          featureType: 'poi',
          stylers: [{ visibility: 'off' }]
        }
      ]
    }}
    onClick={(e) => {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      props.onLocationSelect(lat, lng);
    }}
  >
    {props.lat && props.lng && (
      <Marker position={{ lat: props.lat, lng: props.lng }} />
    )}
  </GoogleMap>
));

class TimeoutSignsSettingsForm extends Component {

  state = {
    modalVisible: false,
    parkingCoords: null
  }

  form = null;

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
    if (nextProps.initialValues && nextProps.initialValues.coreParkingLocationId && nextProps.initialValues.coreParkingLocationId !== (this.props.initialValues && this.props.initialValues.coreParkingLocationId)) {
      ParkinglocationModel.get(nextProps.initialValues.coreParkingLocationId).then(data => {
        if (data && data.Point && data.Point.coordinates) {
          this.setState({ parkingCoords: data.Point.coordinates });
        }
      });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (values.coreParkingLocationId && values.placeID) {
          values.eventListener = 'application/parking/' + values.coreParkingLocationId + '/place/' + values.placeID;
        }
        if (values.placeID) delete values.placeID;
        let position = {
          "type": "Point",
          "coordinates": [
            values.positionLon !== undefined ? values.positionLon : 0.0,
            values.positionLat !== undefined ? values.positionLat : 0.0
          ]
        };
        values.coords = position;
        delete values.positionLat;
        delete values.positionLon;

        if ((!values.mondayFrom || !values.mondayTo) || (values.mondayFrom > values.mondayTo)) {
          values.mondayFrom = moment('00:00', 'HH:mm');
          values.mondayTo = moment('23:59', 'HH:mm');
        }

        if ((!values.tuesdayFrom || !values.tuesdayTo) || (values.tuesdayFrom > values.tuesdayTo)) {
          values.tuesdayFrom = moment('00:00', 'HH:mm');
          values.tuesdayTo = moment('23:59', 'HH:mm');
        }

        if ((!values.wednesdayFrom || !values.wednesdayTo) || (values.wednesdayFrom > values.wednesdayTo)) {
          values.wednesdayFrom = moment('00:00', 'HH:mm');
          values.wednesdayTo = moment('23:59', 'HH:mm');
        }

        if ((!values.thursdayFrom || !values.thursdayTo) || (values.thursdayFrom > values.thursdayTo)) {
          values.thursdayFrom = moment('00:00', 'HH:mm');
          values.thursdayTo = moment('23:59', 'HH:mm');
        }

        if ((!values.fridayFrom || !values.fridayTo) || (values.fridayFrom > values.fridayTo)) {
          values.fridayFrom = moment('00:00', 'HH:mm');
          values.fridayTo = moment('23:59', 'HH:mm');
        }

        if ((!values.saturdayFrom || !values.saturdayTo) || (values.saturdayFrom > values.saturdayTo)) {
          values.saturdayFrom = moment('00:00', 'HH:mm');
          values.saturdayTo = moment('23:59', 'HH:mm');
        }

        if ((!values.sundayFrom || !values.sundayTo) || (values.sundayFrom > values.sundayTo)) {
          values.sundayFrom = moment('00:00', 'HH:mm');
          values.sundayTo = moment('23:59', 'HH:mm');
        }

        let activeHours = {
          "Monday": [values.mondayFrom.format('HH:mm') + '-' + values.mondayTo.format('HH:mm')],
          "Tuesday": [values.tuesdayFrom.format('HH:mm') + '-' + values.tuesdayTo.format('HH:mm')],
          "Wednesday": [values.wednesdayFrom.format('HH:mm') + '-' + values.wednesdayTo.format('HH:mm')],
          "Thursday": [values.thursdayFrom.format('HH:mm') + '-' + values.thursdayTo.format('HH:mm')],
          "Friday": [values.fridayFrom.format('HH:mm') + '-' + values.fridayTo.format('HH:mm')],
          "Saturday": [values.saturdayFrom.format('HH:mm') + '-' + values.saturdayTo.format('HH:mm')],
          "Sunday": [values.sundayFrom.format('HH:mm') + '-' + values.sundayTo.format('HH:mm')]
        };

        values.activeHours = activeHours;
        delete values.mondayFrom;
        delete values.mondayTo;
        delete values.tuesdayFrom;
        delete values.tuesdayTo;
        delete values.wednesdayFrom;
        delete values.wednesdayTo;
        delete values.thursdayFrom;
        delete values.thursdayTo;
        delete values.fridayFrom;
        delete values.fridayTo;
        delete values.saturdayFrom;
        delete values.saturdayTo;
        delete values.sundayFrom;
        delete values.sundayTo;
        this.props.onSuccess(this.props.form, values);
      }
    });
  }

  validateTimeRange(callback, day) {
    const dayFromValue = this.props.form.getFieldValue(`${day}From`);
    const dayToValue = this.props.form.getFieldValue(`${day}To`);

    if (dayFromValue && dayToValue && dayFromValue > dayToValue) {
      callback('čas "Od" musí být před časem "Do".');
    } else {
      callback();
    }
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    if (this.props.initialValues !== undefined && this.props.initialValues !== null) {
      var res = this.props.initialValues.eventListener.split("/");
      this.props.initialValues.placeID = res[4];
    }

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="Časovač" >
          {getFieldDecorator('timerName', {
            initialValue: this.props.initialValues && this.props.initialValues.timerName
              ? this.props.initialValues.timerName
              : null,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Popis" >
          {getFieldDecorator('description', {
            initialValue: this.props.initialValues && this.props.initialValues.description !== null
              ? this.props.initialValues.description
              : '',
          })(
            <Input.TextArea autosize={{ minRows: 2, maxRows: 4 }} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Lokalita" >
          {getFieldDecorator('coreParkingLocationId', {
            initialValue: this.props.initialValues && this.props.initialValues.coreParkingLocationId
              ? this.props.initialValues.coreParkingLocationId
              : undefined,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <TimeoutSignsParkinglocationsSelect onChange={(value) => {
              this.props.form.setFieldsValue({ coreParkingLocationId: value });
              if (value) {
                ParkinglocationModel.get(value).then(data => {
                  console.log('Parking location details:', data);
                  if (data && data.Point && data.Point.coordinates) {
                    this.props.form.setFieldsValue({ positionLat: null, positionLon: null });
                    this.setState({ parkingCoords: data.Point.coordinates });
                  }
                });
              } else {
                this.setState({ parkingCoords: null });
              }
            }} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Místo" >
          {getFieldDecorator('placeID', {
            initialValue: this.props.initialValues && this.props.initialValues.placeID
              ? this.props.initialValues.placeID
              : null,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Nastavený limit (min)" >
          {getFieldDecorator('timeLimit', {
            initialValue: this.props.initialValues && this.props.initialValues.timeLimit
              ? this.props.initialValues.timeLimit
              : 30,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Zeměpisná šířka" >
          {getFieldDecorator('positionLat', {
            initialValue: this.props.initialValues && this.props.initialValues.coords
              ? this.props.initialValues.coords.coordinates[1]
              : undefined,
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }],
          })(
            <InputNumber
              style={{ width: '120px' }}
            />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Zeměpisná výška" >
          {getFieldDecorator('positionLon', {
            initialValue: this.props.initialValues && this.props.initialValues.coords
              ? this.props.initialValues.coords.coordinates[0]
              : undefined,
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }],
          })(
            <InputNumber
              style={{ width: '120px' }}
            />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Vybrat pozici z mapy" >
          <SelectableMap
            lat={this.props.form.getFieldValue('positionLat') || (this.props.initialValues && this.props.initialValues.coords ? this.props.initialValues.coords.coordinates[1] : 50.0008306)}
            lng={this.props.form.getFieldValue('positionLon') || (this.props.initialValues && this.props.initialValues.coords ? this.props.initialValues.coords.coordinates[0] : 14.6637575)}
            centerLat={(!this.props.initialValues || !this.props.initialValues.coords || !this.props.initialValues.coords.coordinates[0] || this.props.initialValues.coords.coordinates[0] === 0) ? (this.state.parkingCoords ? this.state.parkingCoords[1] : 50.0008306) : (this.props.form.getFieldValue('positionLat') || (this.props.initialValues && this.props.initialValues.coords ? this.props.initialValues.coords.coordinates[1] : 50.0008306))}
            centerLng={(!this.props.initialValues || !this.props.initialValues.coords || !this.props.initialValues.coords.coordinates[0] || this.props.initialValues.coords.coordinates[0] === 0) ? (this.state.parkingCoords ? this.state.parkingCoords[0] : 14.6637575) : (this.props.form.getFieldValue('positionLon') || (this.props.initialValues && this.props.initialValues.coords ? this.props.initialValues.coords.coordinates[0] : 14.6637575))}
            zoom={this.props.initialValues && this.props.initialValues.coords.coordinates[0] && this.props.initialValues.coords.coordinates[1] ? 18 : 13}
            onLocationSelect={(lat, lng) => {
              this.props.form.setFieldsValue({ positionLat: lat, positionLon: lng });
            }}
          />
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Vynutit neaktivitu" >
          {getFieldDecorator('forceInactive', {
            valuePropName: 'checked',
            initialValue: this.props.initialValues && this.props.initialValues.forceInactive
              ? this.props.initialValues.forceInactive
              : false,
          })(
            <Switch />
          )}
        </FormItem>
        <Divider />
        <FormItem
          {...formItemLayout}
          label="Pondělí"
        >
          <Col span={11}>
            {getFieldDecorator('mondayFrom', {
              initialValue: this.props.initialValues && this.props.initialValues.activeHours && this.props.initialValues.activeHours.Monday[0]
                ? moment(this.props.initialValues.activeHours.Monday[0].split('-')[0], 'HH:mm')
                : moment('00:00', 'HH:mm'),
              rules: [{
                validator: (rule, value, callback) => {
                  this.validateTimeRange(callback, 'monday');
                }
              }],
            })(
              <TimePicker format='HH:mm' />
            )}
          </Col>
          <Col span={2} style={{ textAlign: 'center' }}>
            <span> - </span>
          </Col>
          <Col span={11}>
            {getFieldDecorator('mondayTo', {
              initialValue: this.props.initialValues && this.props.initialValues.activeHours && this.props.initialValues.activeHours.Monday[0]
                ? moment(this.props.initialValues.activeHours.Monday[0].split('-')[1], 'HH:mm')
                : moment('23:59', 'HH:mm'),
              rules: [{
                validator: (rule, value, callback) => {
                  this.validateTimeRange(callback, 'monday');
                }
              }],
            })(
              <TimePicker format='HH:mm' />
            )}
          </Col>
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Úterý"
        >
          <Col span={11}>
            {getFieldDecorator('tuesdayFrom', {
              initialValue: this.props.initialValues && this.props.initialValues.activeHours && this.props.initialValues.activeHours.Tuesday[0]
                ? moment(this.props.initialValues.activeHours.Tuesday[0].split('-')[0], 'HH:mm')
                : moment('00:00', 'HH:mm'),
              rules: [{
                validator: (rule, value, callback) => {
                  this.validateTimeRange(callback, 'tuesday');
                }
              }],
            })(
              <TimePicker format='HH:mm' />
            )}
          </Col>
          <Col span={2} style={{ textAlign: 'center' }}>
            <span> - </span>
          </Col>
          <Col span={11}>
            {getFieldDecorator('tuesdayTo', {
              initialValue: this.props.initialValues && this.props.initialValues.activeHours && this.props.initialValues.activeHours.Tuesday[0]
                ? moment(this.props.initialValues.activeHours.Tuesday[0].split('-')[1], 'HH:mm')
                : moment('23:59', 'HH:mm'),
              rules: [{
                validator: (rule, value, callback) => {
                  this.validateTimeRange(callback, 'tuesday');
                }
              }],
            })(
              <TimePicker format='HH:mm' />
            )}
          </Col>
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Středa"
        >
          <Col span={11}>
            {getFieldDecorator('wednesdayFrom', {
              initialValue: this.props.initialValues && this.props.initialValues.activeHours && this.props.initialValues.activeHours.Wednesday[0]
                ? moment(this.props.initialValues.activeHours.Wednesday[0].split('-')[0], 'HH:mm')
                : moment('00:00', 'HH:mm'),
              rules: [{
                validator: (rule, value, callback) => {
                  this.validateTimeRange(callback, 'wednesday');
                }
              }],
            })(
              <TimePicker format='HH:mm' />
            )}
          </Col>
          <Col span={2} style={{ textAlign: 'center' }}>
            <span> - </span>
          </Col>
          <Col span={11}>
            {getFieldDecorator('wednesdayTo', {
              initialValue: this.props.initialValues && this.props.initialValues.activeHours && this.props.initialValues.activeHours.Wednesday[0]
                ? moment(this.props.initialValues.activeHours.Wednesday[0].split('-')[1], 'HH:mm')
                : moment('23:59', 'HH:mm'),
              rules: [{
                validator: (rule, value, callback) => {
                  this.validateTimeRange(callback, 'wednesday');
                }
              }],
            })(
              <TimePicker format='HH:mm' />
            )}
          </Col>
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Čtvrtek"
        >
          <Col span={11}>
            {getFieldDecorator('thursdayFrom', {
              initialValue: this.props.initialValues && this.props.initialValues.activeHours && this.props.initialValues.activeHours.Thursday[0]
                ? moment(this.props.initialValues.activeHours.Thursday[0].split('-')[0], 'HH:mm')
                : moment('00:00', 'HH:mm'),
              rules: [{
                validator: (rule, value, callback) => {
                  this.validateTimeRange(callback, 'thursday');
                }
              }],
            })(
              <TimePicker format='HH:mm' />
            )}
          </Col>
          <Col span={2} style={{ textAlign: 'center' }}>
            <span> - </span>
          </Col>
          <Col span={11}>
            {getFieldDecorator('thursdayTo', {
              initialValue: this.props.initialValues && this.props.initialValues.activeHours && this.props.initialValues.activeHours.Thursday[0]
                ? moment(this.props.initialValues.activeHours.Thursday[0].split('-')[1], 'HH:mm')
                : moment('23:59', 'HH:mm'),
              rules: [{
                validator: (rule, value, callback) => {
                  this.validateTimeRange(callback, 'thursday');
                }
              }],
            })(
              <TimePicker format='HH:mm' />
            )}
          </Col>
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Pátek"
        >
          <Col span={11}>
            {getFieldDecorator('fridayFrom', {
              initialValue: this.props.initialValues && this.props.initialValues.activeHours && this.props.initialValues.activeHours.Friday[0]
                ? moment(this.props.initialValues.activeHours.Friday[0].split('-')[0], 'HH:mm')
                : moment('00:00', 'HH:mm'),
              rules: [{
                validator: (rule, value, callback) => {
                  this.validateTimeRange(callback, 'friday');
                }
              }],
            })(
              <TimePicker format='HH:mm' />
            )}
          </Col>
          <Col span={2} style={{ textAlign: 'center' }}>
            <span> - </span>
          </Col>
          <Col span={11}>
            {getFieldDecorator('fridayTo', {
              initialValue: this.props.initialValues && this.props.initialValues.activeHours && this.props.initialValues.activeHours.Friday[0]
                ? moment(this.props.initialValues.activeHours.Friday[0].split('-')[1], 'HH:mm')
                : moment('23:59', 'HH:mm'),
              rules: [{
                validator: (rule, value, callback) => {
                  this.validateTimeRange(callback, 'friday');
                }
              }],
            })(
              <TimePicker format='HH:mm' />
            )}
          </Col>
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Sobota"
        >
          <Col span={11}>
            {getFieldDecorator('saturdayFrom', {
              initialValue: this.props.initialValues && this.props.initialValues.activeHours && this.props.initialValues.activeHours.Saturday[0]
                ? moment(this.props.initialValues.activeHours.Saturday[0].split('-')[0], 'HH:mm')
                : moment('00:00', 'HH:mm'),
              rules: [{
                validator: (rule, value, callback) => {
                  this.validateTimeRange(callback, 'saturday');
                }
              }],
            })(
              <TimePicker format='HH:mm' />
            )}
          </Col>
          <Col span={2} style={{ textAlign: 'center' }}>
            <span> - </span>
          </Col>
          <Col span={11}>
            {getFieldDecorator('saturdayTo', {
              initialValue: this.props.initialValues && this.props.initialValues.activeHours && this.props.initialValues.activeHours.Saturday[0]
                ? moment(this.props.initialValues.activeHours.Saturday[0].split('-')[1], 'HH:mm')
                : moment('23:59', 'HH:mm'),
              rules: [{
                validator: (rule, value, callback) => {
                  this.validateTimeRange(callback, 'saturday');
                }
              }],
            })(
              <TimePicker format='HH:mm' />
            )}
          </Col>
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Neděle"
        >
          <Col span={11}>
            {getFieldDecorator('sundayFrom', {
              initialValue: this.props.initialValues && this.props.initialValues.activeHours && this.props.initialValues.activeHours.Sunday[0]
                ? moment(this.props.initialValues.activeHours.Sunday[0].split('-')[0], 'HH:mm')
                : moment('00:00', 'HH:mm'),
              rules: [{
                validator: (rule, value, callback) => {
                  this.validateTimeRange(callback, 'sunday');
                }
              }],
            })(
              <TimePicker format='HH:mm' />
            )}
          </Col>
          <Col span={2} style={{ textAlign: 'center' }}>
            <span> - </span>
          </Col>
          <Col span={11}>
            {getFieldDecorator('sundayTo', {
              initialValue: this.props.initialValues && this.props.initialValues.activeHours && this.props.initialValues.activeHours.Sunday[0]
                ? moment(this.props.initialValues.activeHours.Sunday[0].split('-')[1], 'HH:mm')
                : moment('23:59', 'HH:mm'),
              rules: [{
                validator: (rule, value, callback) => {
                  this.validateTimeRange(callback, 'sunday');
                }
              }],
            })(
              <TimePicker format='HH:mm' />
            )}
          </Col>
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          {this.props.initialValues
            ?
            <Button type="primary" htmlType="submit">Uložit</Button>
            :
            <Button type="primary" htmlType="submit">Vložit</Button>
          }
        </FormItem>
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={700}
          title={this.props.initialValues ? "Nastavení timeout tabule" : "Vložení nové timeout tabule"}
          visible={this.state.modalVisible}
          maskClosable={false}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
          okText={this.props.initialValues ? "Uložit" : "Vložit"}
        >
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationForm = Form.create()(TimeoutSignsSettingsForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/TimeoutSignsSettingsForm.js